export const SUBTITLE_SIZE_OPTIONS = [50, 75, 100, 150, 200];
